import { render, staticRenderFns } from "./algorithm.vue?vue&type=template&id=7d9021f8&scoped=true&"
import script from "./algorithm.vue?vue&type=script&lang=js&"
export * from "./algorithm.vue?vue&type=script&lang=js&"
import style0 from "./algorithm.vue?vue&type=style&index=0&id=7d9021f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9021f8",
  null
  
)

export default component.exports